module.exports = __webpack_public_path__ + "img/crusher.12e2bdab.png";